import {
  TABLE_HEADER_ATHLETE,
  TABLE_HEADER_ATHLETE_FREE_FORM,
} from "constants/dashboard";
import { SortConfig } from "types/common";
import { TableHeaderButton } from "./TableHeaderButton";
import Tooltip from "@mui/material/Tooltip";

type Props = {
  onClick: (sortBy: string) => void;
  sortConfig: SortConfig;
  isFreeForm: boolean;
};
export const AthleteTableHeader = ({
  onClick,
  sortConfig,
  isFreeForm,
}: Props) => {
  const TABLE_HEAD = isFreeForm
    ? TABLE_HEADER_ATHLETE_FREE_FORM
    : TABLE_HEADER_ATHLETE;

  return (
    <div>
      <div className="w-full flex items-center text-grayDark text-[10px] px-3 mb-2.5">
        <div className="w-[30px]"></div>
        {TABLE_HEAD.map((item: any) => {
          const isLastAvg = item.sortBy === "lastExamAvg";
          const handleClick = () => {
            onClick(item.sortBy);
          };

          const headerContent = (
            <div
              key={item.title}
              className={
                item.center
                  ? "space-x-1 flex justify-center relative px-2"
                  : "space-x-1 text-left relative px-2"
              }
              style={
                isLastAvg
                  ? {
                      backgroundColor: "rgb(255 181 0)",
                      borderRadius: "12px",
                      width: item.width,
                      minWidth: item.width,
                    }
                  : { width: item.width }
              }
            >
              {item.title && (
                <TableHeaderButton
                  handleClick={handleClick}
                  item={item}
                  sortConfig={sortConfig}
                />
              )}
            </div>
          );

          return isLastAvg ? (
            <Tooltip
              key={item.title}
              placement="top"
              title={
                <div
                  style={{
                    background: "#fff",
                    padding: "16px",
                    color: "#000",
                    border: "none",
                    borderRadius: "8px",
                  }}
                >
                  <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                    <li
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          backgroundColor: "#52B788",
                          borderRadius: "50%",
                          marginRight: "12px",
                        }}
                      ></span>
                      Level 1 - Green - Normal
                    </li>
                    <li
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          backgroundColor: "#FF9549",
                          borderRadius: "50%",
                          marginRight: "12px",
                        }}
                      ></span>
                      Level 2 - Orange - Significant
                    </li>
                    <li style={{ display: "flex", alignItems: "center" }}>
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          backgroundColor: "#C83D57",
                          borderRadius: "50%",
                          marginRight: "12px",
                        }}
                      ></span>
                      Level 3 - Red - Severe
                    </li>
                  </ul>
                </div>
              }
              componentsProps={{
                tooltip: {
                  sx: {
                    border: "none",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                  },
                },
              }}
            >
              {headerContent}
            </Tooltip>
          ) : (
            headerContent
          );
        })}
      </div>
    </div>
  );
};
